// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UserRoleApiModel from "../api-model/UserRoleApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PricingCampaignRole from "../entity/PricingCampaignRole.bs.js";

function execute(json) {
  var api_model = DeccoUtils$Catalyst.resolveResult(UserRoleApiModel.t_decode(json), "PricingCampaignStateMapper.re/roles");
  var role = api_model.role;
  if (role === undefined) {
    return ;
  }
  var role$1 = PricingCampaignRole.roles_from_string(role);
  var user_detail_first_name = api_model.admin_info.first_name;
  var user_detail_last_name = api_model.admin_info.last_name;
  var user_detail_email = api_model.admin_info.email;
  var user_detail = {
    first_name: user_detail_first_name,
    last_name: user_detail_last_name,
    email: user_detail_email
  };
  switch (role$1) {
    case /* USER */0 :
        return {
                TAG: /* User */2,
                _0: user_detail
              };
    case /* CITY_ADMIN */1 :
        return {
                TAG: /* CityAdmin */1,
                _0: user_detail
              };
    case /* BUSINESS_ADMIN */2 :
        return {
                TAG: /* BusinessAdmin */0,
                _0: user_detail
              };
    
  }
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
